module.exports = __webpack_public_path__ + "img/strikethrough.f676ff13.svg";